import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f33f520")

_pushScopeId("data-v-1f33f520")
const _hoisted_1 = {
  class: "container-fluid mx-auto",
  style: {"width":"84%"}
}
const _hoisted_2 = {
  class: "main-page-title",
  style: {"margin-top":"100px"}
}
const _hoisted_3 = { class: "d-lg-flex container-fluid" }
const _hoisted_4 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_5 = { class: "filter-dates-title" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex flex-column flex-md-row align-items-center" }
const _hoisted_8 = { class: "search-button-wrapper mx-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_10 = { class: "show-all-clear-filter align-items-lg-center mx-2 mt-2 mt-md-0 text-nowrap" }
const _hoisted_11 = { class: "dashboard container-fluid container-flex" }
const _hoisted_12 = { class: "row my-4" }
const _hoisted_13 = {
  class: "pb-2",
  style: {"width":"20%","padding-inline":"1rem 0.25rem"}
}
const _hoisted_14 = { class: "block dark-blue" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  class: "pb-2 px-1",
  style: {"width":"20%"}
}
const _hoisted_18 = { class: "block dark-blue" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  class: "pb-2 px-1",
  style: {"width":"20%"}
}
const _hoisted_22 = { class: "block dark-blue" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  class: "pb-2 px-1",
  style: {"width":"20%"}
}
const _hoisted_26 = { class: "block dark-blue" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = {
  class: "pb-2",
  style: {"width":"20%","padding-inline":"0.25rem 1rem"}
}
const _hoisted_30 = { class: "block dark-blue" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "row mb-4" }
const _hoisted_34 = { class: "col-md-12 pb-2 px-4" }
const _hoisted_35 = {
  class: "title two-line-md-only",
  style: {"font-size":"20px"}
}
const _hoisted_36 = {
  class: "block pt-0",
  style: {"box-shadow":"none"}
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-12 pb-2 px-3" }
const _hoisted_39 = {
  class: "block",
  style: {"box-shadow":"none"}
}
const _hoisted_40 = { class: "row w-100 justify-content-between" }
const _hoisted_41 = { class: "col-3" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-5" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "default-title" }, " ", -1)
const _hoisted_45 = { class: "col-5" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "default-title" }, " ", -1)
const _hoisted_47 = {
  key: 0,
  class: "col-6"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-2 show-all-clear-filter align-items-lg-center mx-0" }
const _hoisted_50 = { class: "col-5" }
const _hoisted_51 = { class: "default-title" }
const _hoisted_52 = { class: "default-text" }
const _hoisted_53 = { class: "col-5" }
const _hoisted_54 = { class: "default-title" }
const _hoisted_55 = { class: "default-text" }
const _hoisted_56 = {
  key: 1,
  class: "col-9"
}
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-2 show-all-clear-filter align-items-lg-center mx-0 px-2" }
const _hoisted_59 = { class: "col-2 px-2" }
const _hoisted_60 = { class: "default-title" }
const _hoisted_61 = { class: "default-text" }
const _hoisted_62 = { class: "col-4 px-2" }
const _hoisted_63 = { class: "default-title" }
const _hoisted_64 = { class: "d-flex" }
const _hoisted_65 = {
  class: "col-6 px-2",
  style: {"padding-inline-start":"0 !important"}
}
const _hoisted_66 = {
  class: "col-6 px-2",
  style: {"padding-inline-end":"0 !important"}
}
const _hoisted_67 = { class: "col-2 px-2" }
const _hoisted_68 = { class: "default-title" }
const _hoisted_69 = { class: "default-text" }
const _hoisted_70 = { class: "col-2 px-2" }
const _hoisted_71 = { class: "default-title" }
const _hoisted_72 = { class: "default-text" }
const _hoisted_73 = { class: "row mb-3 desktop-grid pt-0" }
const _hoisted_74 = {
  key: 0,
  class: "col-md-12 pb-2 px-4"
}
const _hoisted_75 = { class: "w100" }
const _hoisted_76 = { style: {"width":"20%"} }
const _hoisted_77 = { style: {"width":"20%"} }
const _hoisted_78 = { style: {"width":"10%"} }
const _hoisted_79 = { style: {"width":"10%"} }
const _hoisted_80 = { style: {"width":"10%"} }
const _hoisted_81 = { style: {"width":"10%"} }
const _hoisted_82 = { style: {"width":"10%"} }
const _hoisted_83 = { style: {"width":"10%"} }
const _hoisted_84 = { class: "desktop-table-text-setting" }
const _hoisted_85 = { class: "cuted-cell" }
const _hoisted_86 = { class: "desktop-table-text-setting" }
const _hoisted_87 = { class: "cuted-cell" }
const _hoisted_88 = { class: "desktop-table-text-setting" }
const _hoisted_89 = { class: "cuted-cell" }
const _hoisted_90 = { class: "desktop-table-text-setting" }
const _hoisted_91 = { class: "cuted-cell" }
const _hoisted_92 = { class: "desktop-table-text-setting" }
const _hoisted_93 = { class: "cuted-cell" }
const _hoisted_94 = { class: "desktop-table-text-setting" }
const _hoisted_95 = { class: "cuted-cell" }
const _hoisted_96 = { class: "desktop-table-text-setting" }
const _hoisted_97 = { class: "cuted-cell" }
const _hoisted_98 = { class: "desktop-table-text-setting" }
const _hoisted_99 = { class: "cuted-cell" }
const _hoisted_100 = {
  key: 1,
  class: "col-md-12 pb-2 px-4"
}
const _hoisted_101 = { class: "w100" }
const _hoisted_102 = { style: {"width":"15%"} }
const _hoisted_103 = { style: {"width":"15%"} }
const _hoisted_104 = { style: {"width":"10%"} }
const _hoisted_105 = { style: {"width":"10%"} }
const _hoisted_106 = { style: {"width":"10%"} }
const _hoisted_107 = { style: {"width":"10%"} }
const _hoisted_108 = { style: {"width":"10%"} }
const _hoisted_109 = { style: {"width":"10%"} }
const _hoisted_110 = { style: {"width":"10%"} }
const _hoisted_111 = { class: "desktop-table-text-setting" }
const _hoisted_112 = { class: "cuted-cell" }
const _hoisted_113 = { class: "desktop-table-text-setting" }
const _hoisted_114 = { class: "cuted-cell" }
const _hoisted_115 = { class: "desktop-table-text-setting" }
const _hoisted_116 = { class: "cuted-cell" }
const _hoisted_117 = { class: "desktop-table-text-setting" }
const _hoisted_118 = { class: "cuted-cell" }
const _hoisted_119 = { class: "desktop-table-text-setting" }
const _hoisted_120 = { class: "cuted-cell" }
const _hoisted_121 = { class: "desktop-table-text-setting" }
const _hoisted_122 = { class: "cuted-cell" }
const _hoisted_123 = { class: "desktop-table-text-setting" }
const _hoisted_124 = { class: "cuted-cell" }
const _hoisted_125 = { class: "desktop-table-text-setting" }
const _hoisted_126 = { class: "cuted-cell" }
const _hoisted_127 = { class: "desktop-table-text-setting" }
const _hoisted_128 = { class: "cuted-cell" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_TimelineBlock = _resolveComponent("TimelineBlock")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pageTitle.index-statistics')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('index-statistics.filter.filter-by-dates')), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              _createVNode(_component_Calendar, {
                modelValue: _ctx.dateRange.fromDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                maxDate: _ctx.dateRange.toDate,
                class: "calendar-filter"
              }, null, 8, ["modelValue", "maxDate"]),
              _createVNode(_component_Calendar, {
                modelValue: _ctx.dateRange.toDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                minDate: _ctx.dateRange.fromDate,
                class: "calendar-filter mx-md-3"
              }, null, 8, ["modelValue", "minDate"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
                }, [
                  _hoisted_9
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAll())),
                  class: "fs-18"
                }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('index-statistics.active-users')), 1),
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.indexStatistics.indexActiveUsers), 1)
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('index-statistics.quotes-qty')), 1),
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.indexStatistics.quotes), 1)
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('index-statistics.index-users-use-chat')), 1),
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.indexStatistics.indexUsersChat), 1)
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('index-statistics.providers-use-chat')), 1),
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.indexStatistics.providersChat), 1)
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('index-statistics.products-downloads')), 1),
            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.indexStatistics.productDownloads), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('index-statistics.timeline')), 1),
          _createVNode("div", _hoisted_36, [
            _createVNode(_component_TimelineBlock, {
              data: _ctx.timeline.data,
              showLegend: true
            }, null, 8, ["data"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("button", {
                      class: ["promo-cat-button mb-2", { active: _ctx.isProductsTablesChosed }],
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isProductsTablesChosed = true))
                    }, _toDisplayString(_ctx.$t('title.products')), 3)
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode("button", {
                      class: ["promo-cat-button mb-2", { active: !_ctx.isProductsTablesChosed }],
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isProductsTablesChosed = false))
                    }, _toDisplayString(_ctx.$t('title.users')), 3)
                  ])
                ])
              ]),
              (_ctx.isProductsTablesChosed)
                ? (_openBlock(), _createBlock("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createVNode("div", _hoisted_49, [
                        _createVNode("span", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.providerName = _ctx.productName = null))
                        }, _toDisplayString(_ctx.$t('button.showAll')), 1)
                      ]),
                      _createVNode("div", _hoisted_50, [
                        _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('promo.providerName')) + ":", 1),
                        _createVNode("div", _hoisted_52, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.providerName,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.providerName = $event)),
                            label: "agencyname",
                            "track-by": "agencyname",
                            multiple: false,
                            options: [...new Set(_ctx.indexStatistics.indexProductsTable.map(x => x.providerName))],
                            "close-on-select": false,
                            "show-labels": false,
                            searchable: true,
                            placeholder: "",
                            onSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.productName = null))
                          }, null, 8, ["modelValue", "options"]),
                          (_ctx.providerName)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.providerName = null))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_53, [
                        _createVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('product.productName')) + ":", 1),
                        _createVNode("div", _hoisted_55, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.productName,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.productName = $event)),
                            label: "productName",
                            "track-by": "productName",
                            multiple: false,
                            options: _ctx.providerName ?
                                                    _ctx.indexStatistics.indexProductsTable.filter(x => x.providerName == _ctx.providerName).map(x => x.productName) :
                                                    _ctx.indexStatistics.indexProductsTable.map(x => x.productName),
                            "close-on-select": false,
                            "show-labels": false,
                            searchable: true,
                            placeholder: ""
                          }, null, 8, ["modelValue", "options"]),
                          (_ctx.productName)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.productName = null))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("span", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.agencyName = _ctx.username = _ctx.userActive = _ctx.lastUserActionOnWebsiteRange.fromDate = _ctx.lastUserActionOnWebsiteRange.toDate = null))
                        }, _toDisplayString(_ctx.$t('button.showAll')), 1)
                      ]),
                      _createVNode("div", _hoisted_59, [
                        _createVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('index-statistics.active-users')) + ":", 1),
                        _createVNode("div", _hoisted_61, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.userActive,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.userActive = $event)),
                            valueProp: "id",
                            label: "name",
                            "track-by": "id",
                            multiple: false,
                            options: _ctx.userActiveOptions(),
                            "close-on-select": false,
                            "show-labels": false,
                            searchable: true,
                            placeholder: ""
                          }, null, 8, ["modelValue", "options"]),
                          (_ctx.userActive)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userActive = null))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_62, [
                        _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('index-statistics.last-user-activity')), 1),
                        _createVNode("div", _hoisted_64, [
                          _createVNode("div", _hoisted_65, [
                            _createVNode(_component_Calendar, {
                              modelValue: _ctx.lastUserActionOnWebsiteRange.fromDate,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.lastUserActionOnWebsiteRange.fromDate = $event)),
                              selectionMode: "single",
                              dateFormat: "dd/mm/yy",
                              maxDate: _ctx.lastUserActionOnWebsiteRange.toDate,
                              class: "calendar-filter"
                            }, null, 8, ["modelValue", "maxDate"])
                          ]),
                          _createVNode("div", _hoisted_66, [
                            _createVNode(_component_Calendar, {
                              modelValue: _ctx.lastUserActionOnWebsiteRange.toDate,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.lastUserActionOnWebsiteRange.toDate = $event)),
                              selectionMode: "single",
                              dateFormat: "dd/mm/yy",
                              minDate: _ctx.lastUserActionOnWebsiteRange.fromDate,
                              maxDate: new Date(),
                              class: "calendar-filter"
                            }, null, 8, ["modelValue", "minDate", "maxDate"])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_67, [
                        _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('agentDeatails.agencyName')) + ":", 1),
                        _createVNode("div", _hoisted_69, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.agencyName,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.agencyName = $event)),
                            label: "agencyname",
                            "track-by": "agencyname",
                            multiple: false,
                            options: _ctx.indexStatistics.indexUsersTable.map(x => x.agencyname),
                            "close-on-select": false,
                            "show-labels": false,
                            searchable: true,
                            placeholder: "",
                            onSelect: _cache[19] || (_cache[19] = ($event: any) => (_ctx.username = null))
                          }, null, 8, ["modelValue", "options"]),
                          (_ctx.agencyName)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.agencyName = null))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_70, [
                        _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('title.username')) + ":", 1),
                        _createVNode("div", _hoisted_72, [
                          _createVNode(_component_Multiselect, {
                            modelValue: _ctx.username,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.username = $event)),
                            label: "username",
                            "track-by": "username",
                            multiple: false,
                            options: _ctx.agencyName ?
                                                    _ctx.indexStatistics.indexUsersTable.filter(x => x.agencyname == _ctx.agencyName).map(x => x.username) :
                                                    _ctx.indexStatistics.indexUsersTable.map(x => x.username),
                            "close-on-select": false,
                            "show-labels": false,
                            searchable: true,
                            placeholder: ""
                          }, null, 8, ["modelValue", "options"]),
                          (_ctx.username)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.username = null))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_73, [
        (!_ctx.isProductsTablesChosed)
          ? (_openBlock(), _createBlock("div", _hoisted_74, [
              _createVNode("table", _hoisted_75, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_76, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('title.username')), 1)
                    ]),
                    _createVNode("td", _hoisted_77, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('agentDeatails.agencyName')), 1)
                    ]),
                    _createVNode("td", _hoisted_78, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.users-table.authorizations')), 1)
                    ]),
                    _createVNode("td", _hoisted_79, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.users-table.products-visits')), 1)
                    ]),
                    _createVNode("td", _hoisted_80, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.users-table.show-contacts-clicks')), 1)
                    ]),
                    _createVNode("td", _hoisted_81, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.users-table.quotes-requests')), 1)
                    ]),
                    _createVNode("td", _hoisted_82, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.users-table.chats')), 1)
                    ]),
                    _createVNode("td", _hoisted_83, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.products-downloads')), 1)
                    ])
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getIndexUsers(), (row, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", _hoisted_84, [
                        _createVNode("span", _hoisted_85, _toDisplayString(row.username), 1)
                      ]),
                      _createVNode("td", _hoisted_86, [
                        _createVNode("span", _hoisted_87, _toDisplayString(row.agencyname), 1)
                      ]),
                      _createVNode("td", _hoisted_88, [
                        _createVNode("span", _hoisted_89, _toDisplayString(row.authorizations), 1)
                      ]),
                      _createVNode("td", _hoisted_90, [
                        _createVNode("span", _hoisted_91, _toDisplayString(row.productVisits), 1)
                      ]),
                      _createVNode("td", _hoisted_92, [
                        _createVNode("span", _hoisted_93, _toDisplayString(row.showContactsClicks), 1)
                      ]),
                      _createVNode("td", _hoisted_94, [
                        _createVNode("span", _hoisted_95, _toDisplayString(row.quotesRequests), 1)
                      ]),
                      _createVNode("td", _hoisted_96, [
                        _createVNode("span", _hoisted_97, _toDisplayString(row.chats), 1)
                      ]),
                      _createVNode("td", _hoisted_98, [
                        _createVNode("span", _hoisted_99, _toDisplayString(row.productDownloads), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_100, [
              _createVNode("table", _hoisted_101, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_102, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('product.productName')), 1)
                    ]),
                    _createVNode("td", _hoisted_103, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('promo.providerName')), 1)
                    ]),
                    _createVNode("td", _hoisted_104, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.product.results-page-displays')), 1)
                    ]),
                    _createVNode("td", _hoisted_105, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.product.product-page-visits')), 1)
                    ]),
                    _createVNode("td", _hoisted_106, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.show-contacts-pressed')), 1)
                    ]),
                    _createVNode("td", _hoisted_107, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.quotes-qty')), 1)
                    ]),
                    _createVNode("td", _hoisted_108, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.chat-requests')), 1)
                    ]),
                    _createVNode("td", _hoisted_109, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.replied-chats')), 1)
                    ]),
                    _createVNode("td", _hoisted_110, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('index-statistics.downloads')), 1)
                    ])
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getIndexProducts(), (row, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", _hoisted_111, [
                        _createVNode("span", _hoisted_112, _toDisplayString(row.productName), 1)
                      ]),
                      _createVNode("td", _hoisted_113, [
                        _createVNode("span", _hoisted_114, _toDisplayString(row.providerName), 1)
                      ]),
                      _createVNode("td", _hoisted_115, [
                        _createVNode("span", _hoisted_116, _toDisplayString(row.resultsPageDisplays), 1)
                      ]),
                      _createVNode("td", _hoisted_117, [
                        _createVNode("span", _hoisted_118, _toDisplayString(row.productVisits), 1)
                      ]),
                      _createVNode("td", _hoisted_119, [
                        _createVNode("span", _hoisted_120, _toDisplayString(row.showContactsClicks), 1)
                      ]),
                      _createVNode("td", _hoisted_121, [
                        _createVNode("span", _hoisted_122, _toDisplayString(row.quotesQty), 1)
                      ]),
                      _createVNode("td", _hoisted_123, [
                        _createVNode("span", _hoisted_124, _toDisplayString(row.chats), 1)
                      ]),
                      _createVNode("td", _hoisted_125, [
                        _createVNode("span", _hoisted_126, _toDisplayString(row.repliedChats), 1)
                      ]),
                      _createVNode("td", _hoisted_127, [
                        _createVNode("span", _hoisted_128, _toDisplayString(row.downloads), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
      ])
    ])
  ]))
})